import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useScheduleAnalyses from 'hooks/useScheduleAnalyses';
import { scheduleAnalysesSelectors } from "features/scheduleAnalyses";

const ScheduleAnalysesList = () => {
  const { getScheduleAnalyses } = useScheduleAnalyses();
  const { data, pagination } = useCustomSelector(scheduleAnalysesSelectors.getScheduleAnalysesData);
  const fetching = useCustomSelector(scheduleAnalysesSelectors.scheduleAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getScheduleAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ScheduleAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);